import React from 'react'
import styled from '@emotion/styled'

import { ReactComponent as BackArrowWhite } from './icon-back.svg'
import { ReactComponent as Hamburger } from './hamburger.svg'
import { ReactComponent as HamburgerClose } from './hamburger-close.svg'

const iconsMap = {
  BackArrowWhite,
  Hamburger,
  HamburgerClose,
}

export const Icon = (props) => {
  const iconType = props.iconType
  const size = props.size
  const primary = props.primary
  const CustomIcon = styled(iconsMap[iconType] || null)`
    label: CustomIcon;
    height: ${size ? size * 24 + 'px' : 'auto'};
    fill: ${(props) => primary && props.theme.colors.primary};
  `

  return <CustomIcon {...props} />
}
